var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('img',{attrs:{"src":_vm.ENV === 'anjuke' ? _vm.anjuke : _vm.wuba,"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }